import { LitElement } from "lit-element";
import { html } from "lit-html";
import "@ui5/webcomponents/dist/CheckBox";

class CheckboxList extends LitElement {
  static get properties() {
    return {
      boxes: { type: Array },
      selected: { type: Array },
      selectedString: { type: String },
      initialList: { type: String },
    };
  }

  constructor() {
    super();
    this.selected = [];
    this.selectedString = "";
  }

  connectedCallback() {
    super.connectedCallback();
    this.selected = this.stringToList(this.selectedString);
  }

  _isChecked(property) {
    return this.selected.find((item) => item.id === property.id) ? true : false;
  }

  updated(changedProperties) {
    if (changedProperties.has("selected")) {
      this._dispatchListChanged();
    }

    if (changedProperties.has("selectedString")) {
      this.selected = this.stringToList(this.selectedString);
    }
  }

  _getPropertyValueFromId(id) {
    return this.boxes.find((propertyVal) => propertyVal.id == id);
  }

  _handleItemSelected(e) {
    const propValId = e.target.id
    if (this.selected.find((propertyVal) => propertyVal.id == propValId)) {
      this.selected = this.selected.filter(
        (propertyVal) => propertyVal.id != propValId
      );
    } else {
      let propertyValue = this._getPropertyValueFromId(propValId)
      this.selected = [...this.selected, propertyValue];
    }
    this._dispatchListClick();
  }

  stringToList(itemString) {
    let list = itemString?.split(",");
    if (list?.length > 0) {
      return list.map((item) => ({ id: item, value: item }));
    }
    return [];
  }

  _dispatchListChanged() {
    let options = {
      detail: {
        data: this.selected,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("listChanged", options));
  }

  _dispatchListClick() {
    let options = {
      detail: {
        data: this.selected,
      },
      bubbles: true,
      composed: true,
    };
    this.dispatchEvent(new CustomEvent("listClick", options));
  }

  render() {
    return html`
      <style>
        ui5-checkbox {
          --sapFontFamily: var(--kb-font-family-sans);
          --sapContent_LabelColor: var(--kb-property-filter-text);
          --_ui5_checkbox_inner_width_height: var(--kb-property-filter-checkbox-width-height, 1rem);
          --_ui5_checkbox_label_color: var(--kb-property-filter-text);
          margin: var(--kb-property-filter-checkbox-container-margin)
        }
      </style>
      <ul
        style="display: flex;
                   margin: 0;
                   flex-direction: column; 
                   padding: 0;
                   align-items: flex-start;"
      >
        ${this.boxes.map(
          (property) =>
            html`
              <ui5-checkbox
                style="overflow: unset;"
                id=${property.id}
                text=${property.value}
                ?checked=${this._isChecked(property)}
                ?disable=${false}
                @click=${this._handleItemSelected}
              >
              </ui5-checkbox>
            `
        )}
      </ul>
    `;
  }
}

customElements.define("checkbox-list", CheckboxList);
